import styled, { css } from 'styled-components';
import ausLogingLogo from '../../../assets/PNG/Au_login_image.png';
import { Label } from '../../../Components/uielements';
import { media } from '../../../helper/styleHelper';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  ${(props) =>
    props.logo
      ? css`
          background: url(${props.logo}) center center no-repeat;
        `
      : css`
          background: url(${ausLogingLogo}) center center no-repeat;
        `}
  background-size: cover;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 450px;
  padding: 25px;
  border: 1px solid #e6b471;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background: transparent;
  backdrop-filter: brightness(0.6);

  ${media.xxs`
    max-width: 86%;
    padding: 20px;
  `};

  ${media.xs`
    max-width: 86%;
    padding: 20px;
  `};

  ${media.sm`
    max-width: 400px;
    padding: 25px;
  `};

  ${media.md`
    max-width: 420px;
    padding: 25px;
  `};

  ${media.lg`
    max-width: 450px;
    padding: 25px;
  `};

  ${media.xl`
    max-width: 450px;
    padding: 25px;
  `};

  ${media.xxl`
    max-width: 450px;
    padding: 25px;
  `};
`;

export const Title = styled(Label)`
  text-align: center;
  margin-bottom: 30px;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  font-family: Arial, sans-serif;

  ${media.xxs`
    font-size: 16px;
    margin-bottom: 25px;
  `};

  ${media.xs`
    font-size: 16px;
    margin-bottom: 25px;
  `};

  ${media.sm`
    font-size: 18px;
    margin-bottom: 28px;
  `};

  ${media.md`
    font-size: 19px;
    margin-bottom: 28px;
  `};

  ${media.lg`
    font-size: 20px;
    margin-bottom: 30px;
  `};

  ${media.xl`
    font-size: 20px;
    margin-bottom: 30px;
  `};

  ${media.xxl`
    font-size: 20px;
    margin-bottom: 30px;
  `};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Input = styled.input`
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;

  ${media.xxs`
    margin-bottom: 12px;
    padding: 8px;
    font-size: 13px;
  `};

  ${media.xs`
    margin-bottom: 13px;
    padding: 9px;
    font-size: 13px;
  `};

  ${media.sm`
    margin-bottom: 14px;
    padding: 10px;
    font-size: 14px;
  `};

  ${media.md`
    margin-bottom: 15px;
    padding: 10px;
    font-size: 14px;
  `};

  ${media.lg`
    margin-bottom: 15px;
    padding: 10px;
    font-size: 14px;
  `};
`;

export const OtpInput = styled.input`
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;

  ${media.xxs`
    margin-bottom: 12px;
    padding: 8px;
    font-size: 13px;
  `};

  ${media.xs`
    margin-bottom: 13px;
    padding: 9px;
    font-size: 13px;
  `};

  ${media.sm`
    margin-bottom: 14px;
    padding: 10px;
    font-size: 14px;
  `};

  ${media.md`
    margin-bottom: 15px;
    padding: 10px;
    font-size: 14px;
  `};

  ${media.lg`
    margin-bottom: 15px;
    padding: 10px;
    font-size: 14px;
  `};
`;

export const Button = styled.button`
  background-color: #e6b471;
  color: #171a3b;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  gap: 5px;
  justify-content: center;
  font-size: 14px;

  ${media.xxs`
    padding: 8px;
    font-size: 12px;
  `};

  ${media.xs`
    padding: 8px;
    font-size: 13px;
  `};

  ${media.sm`
    padding: 9px;
    font-size: 13px;
  `};

  ${media.md`
    padding: 10px;
    font-size: 14px;
  `};

  ${media.lg`
    padding: 10px;
    font-size: 14px;
  `};

  &:hover {
    opacity: 0.9;
    transition: opacity 0.3s ease;
  }
`;

export const LogoContainer = styled.img`
  width: 280px;
  height: 65px;
  margin-bottom: 10px;

  ${media.xxs`
    width: 200px;
    height: 50px;
  
  `};

  ${media.xs`
    width: 220px;
    height: 55px;
   
  `};

  ${media.sm`
    width: 240px;
    height: 58px;
  `};

  ${media.md`
    width: 260px;
    height: 62px;

  `};

  ${media.lg`
    width: 280px;
    height: 65px;

  `};

  ${media.xl`
    width: 280px;
    height: 65px;

  `};

  ${media.xxl`
    width: 280px;
    height: 65px;
  `};
`;

export const AusGreen = styled.img`
  width: 150px;
  height: 150px;
  margin-top: 8px;

  ${media.xxs`
    width: 100px;
    height: 100px;
    margin-top: 6px;
  `};

  ${media.xs`
    width: 115px;
    height: 115px;
    margin-top: 7px;
  `};

  ${media.sm`
    width: 130px;
    height: 130px;
    margin-top: 7px;
  `};

  ${media.md`
    width: 140px;
    height: 140px;
    margin-top: 8px;
  `};

  ${media.lg`
    width: 150px;
    height: 150px;
    margin-top: 8px;
  `};

  ${media.xl`
    width: 150px;
    height: 150px;
    margin-top: 8px;
  `};

  ${media.xxl`
    width: 150px;
    height: 150px;
    margin-top: 8px;
  `};
`;

export const TagLine = styled(Label)`
  color: #fff;
  font-weight: bold;
  margin-top: 15px;
  padding: 5px;
  border-radius: 5px;
  background-color: rgb(67 64 64 / 45%);
  font-size: 16px;
  font-family: Arial, sans-serif;

  ${media.xxs`
    font-size: 12px;
    margin-top: 12px;
    padding: 4px;
  `};

  ${media.xs`
    font-size: 13px;
    margin-top: 13px;
    padding: 4px;
  `};

  ${media.sm`
    font-size: 14px;
    margin-top: 14px;
    padding: 5px;
  `};

  ${media.md`
    font-size: 15px;
    margin-top: 15px;
    padding: 5px;
  `};

  ${media.lg`
    font-size: 16px;
    margin-top: 15px;
    padding: 5px;
  `};

  ${media.xl`
    font-size: 16px;
    margin-top: 15px;
    padding: 5px;
  `};

  ${media.xxl`
    font-size: 16px;
    margin-top: 15px;
    padding: 5px;
  `};
`;

export const ButtonWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  margin-top: 20px;
  gap: 10px;

  ${media.xxs`
    margin-top: 15px;
    gap: 8px;
  `};

  ${media.xs`
    margin-top: 15px;
    gap: 8px;
  `};

  ${media.sm`
    margin-top: 16px;
    gap: 9px;
  `};

  ${media.md`
    margin-top: 18px;
    gap: 10px;
  `};

  ${media.lg`
    margin-top: 20px;
    gap: 10px;
  `};
`;

export const TextButton = styled(Label)`
  cursor: pointer;
  font-family: Arial, Helvetica, sans-serif;
  color: #fff;
  font-size: 14px;
  font-weight: normal;

  ${media.xxs`
    font-size: 12px;
  `};

  ${media.xs`
    font-size: 12px;
  `};

  ${media.sm`
    font-size: 13px;
  `};

  ${media.md`
    font-size: 14px;
  `};

  ${media.lg`
    font-size: 14px;
  `};

  &:hover {
    text-decoration: underline;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const IconButton = styled.div`
  position: absolute;
  right: 10px;
  top: 38%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.xxs`
    right: 8px;
  `};

  ${media.xs`
    right: 9px;
  `};

  ${media.sm`
    right: 10px;
  `};

  ${media.md`
    right: 10px;
  `};

  ${media.lg`
    right: 10px;
  `};
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;

  ${media.xxs`
    gap: 10px;
  `};

  ${media.xs`
    gap: 10px;
  `};

  ${media.sm`
    gap: 12px;
  `};

  ${media.md`
    gap: 13px;
  `};

  ${media.lg`
    gap: 15px;
  `};
`;

export const InfoCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin: 20px 0;
  padding: 18px 20px;
  border: 1px solid #e6b471;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.25);
`;

export const InfoIconCircle = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e6b471;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoTextWrapper = styled.div`
  display: grid;
  gap: 4px;
`;

export const InfoTitle = styled(Label)`
  font-family: Arial, sans-serif;
  font-size: 16px !important;
  font-weight: bold;
  color: #fff;
`;

export const InfoDescription = styled(Label)`
  font-family: Arial, sans-serif;
  font-size: 14px !important;
  line-height: 1.5;
  color: #fff;
`;
